// extracted by mini-css-extract-plugin
export var loadingStep = "WithdrawWizard-module--loadingStep--4fda1";
export var titleSkeleton = "WithdrawWizard-module--titleSkeleton--d4175";
export var unsupportedCurrency = "WithdrawWizard-module--unsupportedCurrency--34ac8";